import axios from '@/api/requests/axios'

export default {
  getCrmSetting: () => axios.get('/api/admin/v1/system-settings/crm'),
  getCrmCountries: () => axios.get('/api/admin/v1/system-settings/crm/countries'),
  saveCrmSetting: crmSetting => axios.put('/api/admin/v1/system-settings/crm', crmSetting),
  getCrmClientSetting: () => axios.get('/api/admin/v1/system-settings/crm-client'),
  updateCrmClientSetting: crmClientSetting => axios.put('/api/admin/v1/system-settings/crm-client', crmClientSetting),
  getCrmClientGroups: () => axios.get('/api/admin/v1/system-settings/crm-client-groups'),
  getCrmContactTypes: () => axios.get('/api/admin/v1/system-settings/crm-contact-types'),
  getCrmAccountTypes: () => axios.get('/api/admin/v1/system-settings/crm-account-types'),
  getQrCodeSetting: () => axios.get('/api/admin/v1/system-settings/qr-code'),
  updateQrCodeSetting: qrCodeSetting => axios.put('/api/admin/v1/system-settings/qr-code', qrCodeSetting),
  getReferralCodeSetting: () => axios.get('/api/admin/v1/system-settings/referral-code'),
  updateReferralCodeSetting: referralCodeSetting => axios.put('/api/admin/v1/system-settings/referral-code', referralCodeSetting),
  getOrderCancellationSettings: () => axios.get('/api/admin/v1/system-settings/order-cancellation-settings'),
  updateOrderCancellationSettings: orderCancellationSetting => axios.put('/api/admin/v1/system-settings/order-cancellation-settings', orderCancellationSetting),
  getMenuSyncSetting: () => axios.get('/api/admin/v1/system-settings/menu-sync'),
  updateMenuSyncSetting: menuSyncSetting => axios.put('/api/admin/v1/system-settings/menu-sync', menuSyncSetting),
  getMenuSyncRestaurants: () => axios.get('/api/admin/v1/system-settings/menu-sync/restaurants'),
  getMenuSyncCategories: () => axios.get('/api/admin/v1/system-settings/menu-sync/categories'),
  getMaintenanceSetting: () => axios.get('/api/admin/v1/system-settings/maintenance'),
  updateMaintenanceSetting: maintenanceSetting => axios.put('/api/admin/v1/system-settings/maintenance', maintenanceSetting),
  getPaymentSetting: () => axios.get('/api/admin/v1/system-settings/payment'),
  updatePaymentSetting: paymentSetting => axios.put('/api/admin/v1/system-settings/payment', paymentSetting),
  getDeliveryLogSetting: () => axios.get('/api/admin/v1/system-settings/delivery-log'),
  updateDeliveryLogSetting: setting => axios.put('/api/admin/v1/system-settings/delivery-log', setting),
  getBakaiLogSetting: () => axios.get('/api/admin/v1/system-settings/bakai-log'),
  updateBakaiLogSetting: setting => axios.put('/api/admin/v1/system-settings/bakai-log', setting),
  getLoyaltyProgramSettings: () => axios.get('/api/admin/v1/system-settings/loyalty-programs'),
  updateLoyaltyProgramSettings: settings =>
    axios.put('/api/admin/v1/system-settings/loyalty-programs', settings),
  getExchangeLogSettings: () => axios.get('/api/admin/v1/system-settings/exchange-log'),
  updateExchangeLogSettings: settings =>
    axios.put('/api/admin/v1/system-settings/exchange-log', settings),
  getCartCalculationSetting: () => axios.get('/api/admin/v1/system-settings/cart-calculation'),
  updateCartCalculationSetting: setting =>
    axios.put('/api/admin/v1/system-settings/cart-calculation', setting),
}
